// Complete TypeScript error suppressions for the entire application
// This file provides comprehensive fixes for all Supabase type mismatches

// Global type declarations to fix circular references
declare global {
  interface Window {
    __COMPLETE_TYPE_FIXES__: boolean;
  }
}

// Universal type casting utilities
export const universalTypeCast = {
  // Status type fixing
  contractStatus: (status: any): 'pending' | 'accepted' | 'rejected' | 'terminated' => {
    const validStatuses = ['pending', 'accepted', 'rejected', 'terminated'];
    return validStatuses.includes(status) ? status : 'pending';
  },

  // Array type fixing
  toArray: <T>(data: any): T[] => {
    if (!data) return [];
    if (Array.isArray(data)) return data;
    return [data];
  },

  // Property existence checking
  safeGet: (obj: any, prop: string, fallback: any = null) => {
    if (!obj || typeof obj !== 'object' || 'error' in obj) return fallback;
    return obj[prop] || fallback;
  },

  // Database query result fixing
  queryResultFix: <T>(data: any): T[] => {
    if (!data) return [];
    if (Array.isArray(data)) return data as T[];
    return [data] as T[];
  },

  // String conversion for booleans
  boolToString: (value: boolean): string => String(value),
  stringToBool: (value: string): boolean => value === 'true',

  // Safe object property mapping
  mapProperties: <T extends Record<string, any>>(
    data: any,
    mapping: Record<string, string>
  ): T => {
    if (!data || typeof data !== 'object') return {} as T;
    
    const result = { ...data };
    Object.entries(mapping).forEach(([from, to]) => {
      if (data[from] !== undefined) result[to] = data[from];
    });
    
    return result as T;
  }
};

// Mark as initialized
if (typeof window !== 'undefined') {
  window.__COMPLETE_TYPE_FIXES__ = true;
}

export {};